function Treetop1() {
  return (
    <svg
      className="h-full w-full"
      viewBox="0 0 463.976 306.941"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3" filter="url(#bush-t1-blur)">
        <path
          d="M108.754 175.963C104.588 128.765 156.418 90.9967 179.17 93.1424C189.553 94.1216 197.135 107.515 200.931 141.621C205.097 179.064 140.633 219.001 125.121 215.966C119.289 214.824 110.178 192.096 108.754 175.963Z"
          fill="#073329"
        />
        <path
          d="M200.954 175.739C168.349 141.474 181.421 94.1995 198.921 87.6362C206.907 84.641 220.703 92.0606 244.821 116.539C271.298 143.412 250.62 196.877 237.701 200.16C232.843 201.394 212.098 187.451 200.954 175.739Z"
          fill="#073329"
        />
        <path
          d="M275.225 156.932C228.401 150.016 203.251 111.329 210.418 98.083C213.689 92.0382 228.405 90.1542 262.416 94.6802C299.755 99.6488 324.193 146.362 317.777 155.079C315.364 158.356 291.23 159.296 275.225 156.932Z"
          fill="#073329"
        />
        <path
          d="M66.1896 101.273C96.451 70.6432 149.157 71.4095 159.434 83.1406C164.124 88.4941 158.843 100.118 137.381 122.612C113.819 147.305 53.0984 142.07 47.1718 133.115C44.9435 129.748 55.8459 111.743 66.1896 101.273Z"
          fill="#073329"
        />
        <path
          d="M98.4853 61.7071C129.129 90.9272 122.595 148.818 108.499 161.605C102.067 167.44 89.7681 163.152 67.1822 142.528C42.3867 119.887 54.7331 52.6291 65.2862 44.9724C69.2539 42.0936 88.0108 51.7193 98.4853 61.7071Z"
          fill="#073329"
        />
        <path
          d="M51.8625 78.2992C73.8854 102.481 70.3283 136.247 60.6641 141.044C56.2538 143.233 47.5472 138.043 31.3317 120.774C13.5298 101.816 20.9991 63.5873 28.2684 61.1591C31.0016 60.2461 44.3348 70.0337 51.8625 78.2992Z"
          fill="#073329"
        />
        <path
          d="M166.172 53.0745C188.63 96.7852 163.071 140.252 144.245 141.737C135.653 142.415 124.23 130.996 107.382 99.5306C88.8851 64.9871 123.533 17.5378 137.007 18.0034C142.073 18.1785 158.495 38.1337 166.172 53.0745Z"
          fill="#073329"
        />
        <path
          d="M295.783 58.9926C299.406 100.558 257.5 139.788 239.01 140.339C230.571 140.591 224.345 129.488 221.089 99.537C217.515 66.6557 269.671 24.1284 282.285 25.1527C287.028 25.5379 294.544 44.785 295.783 58.9926Z"
          fill="#073329"
        />
        <path
          d="M228.481 53.2183C237.294 94.845 200.149 129.972 181.671 128.823C173.239 128.298 165.61 116.697 158.612 86.6426C150.93 53.648 197.945 16.1854 210.726 18.3608C215.531 19.1787 225.468 38.9898 228.481 53.2183Z"
          fill="#073329"
        />
        <g>
          <path
            d="M402.401 133.801C386.484 174.125 336.006 182.034 321.293 170.237C314.579 164.853 314.716 150.584 325.681 121.098C337.718 88.7278 397.703 84.63 407.108 93.9552C410.645 97.4614 407.841 120.017 402.401 133.801Z"
            fill="#073329"
          />
          <path
            d="M339.231 93.269C347.914 135.607 320.174 168.381 305.591 166.005C298.936 164.921 292.448 152.779 285.68 122.169C278.25 88.5645 313.656 54.1006 323.8 57.129C327.614 58.2676 336.263 78.7974 339.231 93.269Z"
            fill="#073329"
          />
          <path
            d="M401.824 213.499C368.941 225.111 333.186 201.212 330.819 187.108C329.739 180.671 337.974 173.525 361.602 164.662C387.541 154.932 427.003 186.015 427.497 195.934C427.683 199.663 413.064 209.53 401.824 213.499Z"
            fill="#073329"
          />
          <path
            d="M363.019 245.573C331.786 233.233 316.962 196.913 322.541 186.656C325.087 181.976 335.13 182.409 357.844 190.95C382.779 200.326 396.675 243.362 391.856 249.877C390.044 252.326 373.694 249.79 363.019 245.573Z"
            fill="#073329"
          />
          <path
            d="M310.764 225.145C297.372 192.389 313.507 160.807 325.099 160.1C330.389 159.777 337.304 168.449 347.363 192.042C358.407 217.944 336.644 252.28 328.363 251.657C325.249 251.423 315.342 236.341 310.764 225.145Z"
            fill="#073329"
          />
          <path
            d="M244.327 137.207C275.331 121.572 312.882 141.375 316.683 155.303C318.418 161.659 311.098 169.845 288.875 181.603C264.478 194.511 222.54 167.913 221.014 157.978C220.44 154.243 233.729 142.551 244.327 137.207Z"
            fill="#073329"
          />
          <path
            d="M264.915 195.122C275.436 157.287 314.817 145.048 327.002 154.145C332.563 158.297 333.17 171.125 326.007 198.721C318.144 229.017 271.082 238.802 263.203 231.385C260.24 228.596 261.319 208.054 264.915 195.122Z"
            fill="#073329"
          />
        </g>
      </g>
      <defs>
        <filter
          id="bush-t1-blur"
          x="2.32779"
          y="0"
          width="443.171"
          height="269.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="9" result="effect1_foregroundBlur" />
        </filter>
      </defs>
    </svg>
  )
}

function Treetop2() {
  return (
    <svg
      className="h-full w-full"
      viewBox="0 0 428.599 331.437"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3" filter="url(#bush-t2-blur)">
        <path
          d="M98.515 258.268C93.0945 193.44 160.539 141.563 190.145 144.51C203.656 145.855 213.522 164.251 218.461 211.098C223.882 262.527 139.998 317.383 119.813 313.214C112.224 311.646 100.368 280.428 98.515 258.268Z"
          fill="#073329"
        />
        <path
          d="M218.49 257.96C176.063 210.895 193.073 145.962 215.845 136.947C226.238 132.833 244.189 143.024 275.573 176.646C310.026 213.557 283.119 286.994 266.308 291.503C259.987 293.198 232.992 274.047 218.49 257.96Z"
          fill="#073329"
        />
        <path
          d="M315.136 232.128C254.206 222.628 221.48 169.489 230.806 151.296C235.062 142.993 254.212 140.405 298.469 146.622C347.056 153.446 378.856 217.609 370.507 229.582C367.368 234.084 335.963 235.375 315.136 232.128Z"
          fill="#073329"
        />
        <path
          d="M43.1278 155.678C82.5057 113.606 151.09 114.659 164.463 130.772C170.566 138.125 163.694 154.092 135.766 184.987C105.106 218.905 26.0928 211.714 18.3807 199.414C15.4811 194.79 29.668 170.058 43.1278 155.678Z"
          fill="#073329"
        />
        <path
          d="M76.6394 82.492C130.526 72.4734 177.592 106.75 176.756 124.505C176.375 132.607 161.542 140.357 122.658 148.198C79.9716 156.806 29.5114 113.157 31.8869 100.825C32.7801 96.1886 58.2205 85.9164 76.6394 82.492Z"
          fill="#073329"
        />
        <path
          d="M166.643 65.4515C209.123 96.3455 208.06 150.153 191.791 160.645C184.366 165.433 168.245 160.042 137.049 138.131C102.801 114.077 110.062 52.0867 122.482 46.0362C127.151 43.7613 152.123 54.8916 166.643 65.4515Z"
          fill="#073329"
        />
        <path
          d="M324.786 123.18C290.964 168.852 222.673 174.533 207.348 159.831C200.355 153.122 205.169 136.581 229.024 103.138C255.212 66.4237 334.642 65.8202 343.859 77.2875C347.324 81.599 336.347 107.568 324.786 123.18Z"
          fill="#073329"
        />
        <path
          d="M254.149 66.0026C265.617 123.179 217.283 171.427 193.238 169.849C182.264 169.128 172.338 153.194 163.232 111.912C153.235 66.5929 214.414 15.1364 231.045 18.1243C237.298 19.2477 250.228 46.4592 254.149 66.0026Z"
          fill="#073329"
        />
        <g>
          <path
            d="M377.995 218.372C338.973 224.28 305.43 178.481 306.256 157.546C306.633 147.993 317.437 140.454 345.603 135.466C376.524 129.99 412.399 187.264 410.529 201.607C409.826 206.999 391.334 216.353 377.995 218.372Z"
            fill="#073329"
          />
          <path
            d="M373.936 133.932C346.849 165.315 307.039 155.439 300.853 139.7C298.03 132.518 303.613 119.553 322.929 96.3769C344.134 70.9337 389.405 87.5035 392.674 99.1912C393.903 103.586 383.195 123.205 373.936 133.932Z"
            fill="#073329"
          />
          <path
            d="M355.198 66.7375C351.421 109.932 320.348 134.684 309.047 128.706C303.889 125.978 301.706 112.583 304.037 81.2295C306.595 46.8093 344.363 22.3543 351.872 27.8445C354.695 29.9087 356.489 51.973 355.198 66.7375Z"
            fill="#073329"
          />
          <path
            d="M317.754 260.67C291.046 234.31 289.468 186.001 298.779 176.067C303.028 171.534 312.903 175.856 332.485 194.517C353.983 215.003 352.185 270.852 344.997 276.678C342.295 278.868 326.883 269.68 317.754 260.67Z"
            fill="#073329"
          />
          <path
            d="M272.422 239.444C264.625 201.837 283.831 167.601 294.593 167.616C299.504 167.623 304.668 177.814 310.665 204.93C317.247 234.699 292.484 271.627 284.952 270.353C282.119 269.874 275.087 252.298 272.422 239.444Z"
            fill="#073329"
          />
          <path
            d="M259.214 176.641C276.522 145.742 309.09 144.753 315.959 155.867C319.094 160.938 316.354 172.46 304.113 195.126C290.675 220.009 252.96 216.899 248.9 208.352C247.374 205.139 253.298 187.202 259.214 176.641Z"
            fill="#073329"
          />
          <path
            d="M289.013 63.462C317.72 85.7953 323.359 133.681 314.965 144.943C311.134 150.082 300.978 147.227 279.987 131.516C256.943 114.267 254.014 58.3762 260.65 51.5184C263.145 48.9399 279.201 55.8282 289.013 63.462Z"
            fill="#073329"
          />
          <path
            d="M256.723 115.029C290.923 105.11 321.655 137.575 321.477 154.552C321.396 162.299 312.082 169.801 287.416 177.543C260.337 186.042 227.25 144.639 228.52 132.837C228.997 128.399 245.033 118.419 256.723 115.029Z"
            fill="#073329"
          />
        </g>
      </g>
      <defs>
        <filter
          id="bush-t2-blur"
          x="0"
          y="0"
          width="428.599"
          height="331.437"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="9" result="effect1_foregroundBlur" />
        </filter>
      </defs>
    </svg>
  )
}

export function Bush({ className }: { className?: string }) {
  return (
    <div className={className}>
      <div className="-scale-y-100">
        <div className="relative h-[508.472px] w-[933.347px]">
          {/* Treetop 1 */}
          <div className="absolute bottom-[13.37%] left-[42.32%] right-0 top-0 flex items-center justify-center">
            <div className="h-[292.515px] w-[463.976px] rotate-[21.19deg] -scale-y-100">
              <Treetop1 />
            </div>
          </div>
          {/* Treetop 2 */}
          <div className="absolute bottom-0 left-0 right-[46.97%] top-[1.84%] flex items-center justify-center">
            <div className="h-[300.723px] w-[402.47px] rotate-[-46.67deg] -scale-y-100">
              <Treetop2 />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
